export default (theme) => ({
    dummy: {
        opacity: 0
    },
    flexGrow: {
        flexGrow: 1
    },
    input: {
        margin: theme.spacing(2)
    },
    selectAll: {
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: "sticky",
        top: 0,
        zIndex: 1000,
        transition: theme.transitions.create("background-color"),
        "&:hover": {
            backgroundColor: theme.palette.grey["100"]
        }
    },
    toolbar: {
        backgroundColor: theme.palette.common.white,
        borderTop: `1px solid ${theme.palette.divider}`,
        bottom: 0,
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        position: "sticky",
        zIndex: 1000
    }
});
